import { useLazyQuery } from '@apollo/react-hooks';
import {
  ConversionDisplayOptionsQuery,
  ConversionDisplayOptionsQueryVariables
} from './__generated__/ConversionDisplayOptionsQuery';
import { kmsClient } from 'api';
import { CONVERSION_DISPLAY_OPTIONS_QUERY } from './conversionDisplayOptions.query';

export const useConversionDisplayOptionsLazyQuery = () => {
  return useLazyQuery<ConversionDisplayOptionsQuery, ConversionDisplayOptionsQueryVariables>(
    CONVERSION_DISPLAY_OPTIONS_QUERY,
    {
      client: kmsClient,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true
    }
  );
};
